import React, { useState, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import reportWebVitals from "./reportWebVitals";
import AppRoutes from "./routes";
import { Theme } from "./utils/theme-config";
import Loader from "./core/loader";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AppProvide } from "./utils/context";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import "./styles/index.scss";
import { ErrorBoundary } from "react-error-boundary";
import { getOfflineData } from "./utils/offline-services";
import ErrorFallback from "./core/error-fallback/errorFallback";
import { disableCache } from "@iconify/react";
const theme = createTheme(Theme);

const App = () => {
  const [userDetails, setUserDetails] = useState(getOfflineData("user") || {});
  const [activeRoute, setActiveRoute] = useState("");
  const [
    engineReplacementDashboardFilter,
    setEngineReplacementDashboardFilter,
  ] = useState({});
  const [overviewDashboardFilter, setOverviewDashboardFilter] = useState({});
  disableCache("all");
  return (
    <AppProvide
      value={{
        userDetails,
        setUserDetails,
        activeRoute,
        setActiveRoute,
        engineReplacementDashboardFilter,
        setEngineReplacementDashboardFilter,
        overviewDashboardFilter,
        setOverviewDashboardFilter,
      }}
    >
      <ThemeProvider theme={theme}>
        <Loader />
        <ToastContainer
          autoClose={2000}
          progressClassName="toastProgress"
          bodyClassName="toastBody"
          icon={false}
          closeButton={false}
        />
        <ErrorBoundary fallbackRender={ErrorFallback}>
          <AppRoutes />
        </ErrorBoundary>
      </ThemeProvider>
    </AppProvide>
  );
};

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
